/**
 * ScrollHelper - Tablolarda scroll pozisyonunu korumak için yardımcı sınıf
 */
class ScrollHelper {
    constructor() {
        this.scrollPositions = {}; // Her tablo için scroll pozisyonlarını saklar
        this.isUpdating = {}; // Hangi tablonun güncellenmekte olduğunu izler
    }

    /**
     * Tablo için scroll pozisyonunu kaydeder
     * @param {string} tableId - Tablo kimliği 
     * @param {HTMLElement} container - Scroll içeren container elementi
     */
    saveScrollPosition(tableId, container) {
        if (!container) return;
        
        this.scrollPositions[tableId] = container.scrollTop;
        console.log(`[ScrollHelper] Tablo ${tableId} için scroll pozisyonu kaydedildi:`, this.scrollPositions[tableId]);
    }

    /**
     * Tablo için scroll pozisyonunu geri yükler
     * @param {string} tableId - Tablo kimliği
     * @param {HTMLElement} container - Scroll içeren container elementi
     */
    restoreScrollPosition(tableId, container) {
        if (!container || typeof this.scrollPositions[tableId] === 'undefined') return;
        
        // setTimeout kullanarak DOM güncellenmesinden sonra scroll'u uygula
        setTimeout(() => {
            container.scrollTop = this.scrollPositions[tableId];
            console.log(`[ScrollHelper] Tablo ${tableId} için scroll pozisyonu geri yüklendi:`, this.scrollPositions[tableId]);
        }, 50);
    }

    /**
     * Belirli bir tablo için güncelleme durumunu ayarlar
     * @param {string} tableId - Tablo kimliği
     * @param {boolean} status - Güncelleme durumu 
     */
    setUpdateStatus(tableId, status) {
        this.isUpdating[tableId] = status;
    }

    /**
     * Belirli bir tablonun güncelleme durumunu kontrol eder
     * @param {string} tableId - Tablo kimliği
     * @returns {boolean} - Tablo güncelleniyor mu?
     */
    isTableUpdating(tableId) {
        return !!this.isUpdating[tableId];
    }
}

// Singleton instance
const scrollHelper = new ScrollHelper();
export default scrollHelper;
